var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99811 12.7467L11.433 17.0077C11.7098 17.4922 11.8482 17.7344 11.8482 18C11.8482 18.2656 11.7098 18.5078 11.433 18.9923L8.99811 23.2533C7.75981 25.4203 7.14066 26.5039 7.62348 27.0412C8.1063 27.5785 9.24962 27.0783 11.5362 26.0779L25.8119 19.8323C27.6074 19.0468 28.5051 18.654 28.5051 18C28.5051 17.346 27.6074 16.9532 25.8118 16.1677L11.5362 9.9221C9.24961 8.92171 8.1063 8.42151 7.62348 8.95883C7.14066 9.49615 7.75981 10.5797 8.99811 12.7467Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.26375dfa60927259e882c97e43296979.svg";
export { ForwardRef as ReactComponent };